import React from 'react';
import { NextPage } from 'next';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import WatchEverywhere from '~/src/components/WatchEverywhere';
import Layout from '~/src/features/_layout';
import { initialProps } from '~/src/helpers/basePageFunc';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';

interface IProps {
    city: ICurrentCity,
    companyName: string,
}

const WatchEverywherePage: NextPage<IProps> = ({ city: { cityIn, phone }, companyName }) => {
    return (
        <Layout
            title={`Смотри везде - цифровое ТВ на несколько телевизоров и других устройств от ${companyName} в ${cityIn}`}
            description={`Подключите цифровое ТВ от ${companyName} сразу для нескольких устройств в ${cityIn}. Тарифы для тех, у кого много устройств. Подробнее на сайте или по ☎ ${phone}.`}
            withMenu={true}
            withFooter={true}
            withChat={true}
        >
            <WatchEverywhere/>
        </Layout>
    );
};

WatchEverywherePage.getInitialProps = async(options) => {
    await initialProps(options, { isNeedAuthData: true });
    const { store } = options;
    const state = store.getState();
    const city = getCurrentCity(state);
    const companyName = selectCompanyName(state);

    return { city, companyName };
};

export default WatchEverywherePage;
